Flup.service("favToggler", function(flup) {
    this.toggle = ($element, response) => {
        $element.toggleClass("active", response);
    };
    this.click = ($elm, e) => {
        e.stopPropagation()
        e.preventDefault()
        if (flup.config("flashData").userLoggedIn) {
            flup("server").request({
                url: $elm.data("url"),
                data: {
                    refresh: false,
                    toggle: !$elm.hasClass("active")
                },
                done: (data, res) => {
                    this.toggle($elm)
                },
            });
        }
    };
});

Flup.click("fav-toggler", (flup, $elm, value, e) => {
    flup("favToggler").click($elm, e)
})

